/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiV3ServiceGetReceiptIdGet$Params {

/**
 * Interface language
 */
  lang?: string;

/**
 * transaction id
 */
  trnId?: number;

/**
 * client session ID
 */
  id: string;
}

export function apiV3ServiceGetReceiptIdGet(http: HttpClient, rootUrl: string, params: ApiV3ServiceGetReceiptIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceGetReceiptIdGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('trnId', params.trnId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV3ServiceGetReceiptIdGet.PATH = '/api/v3/service/GetReceipt/{id}';
